import Grid2 from '@mui/material/Unstable_Grid2';
import { Step } from '../../components/Step';
import { useTranslation } from 'react-i18next';
import { SelectCheckbox } from '../../components/SelectCheckbox';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import WorkOffIcon from '@mui/icons-material/WorkOff';
import { mapArrayForSelect } from '../../utils/mapArrayForSelect';

type Step3Props = { departments: string[]; offices: string[]; leaveTypes: string[] };

export const Step3to5 = ({ departments, offices, leaveTypes }: Step3Props) => {
  const { t } = useTranslation('settings');

  const mappedDepartments = mapArrayForSelect(departments);
  const mappedOffices = mapArrayForSelect(offices);
  const mappedLeaveTypes = mapArrayForSelect(leaveTypes);

  const stepsData = [
    {
      stepNumber: '3',
      name: 'departments',
      icon: DashboardIcon,
      data: mappedDepartments,
      subtitle: t('integrations.personio.departments').toLowerCase()
    },
    {
      stepNumber: '4',
      name: 'offices',
      icon: MeetingRoomIcon,
      data: mappedOffices,
      subtitle: t('integrations.personio.offices').toLowerCase()
    },
    {
      stepNumber: '5',
      name: 'leaveTypes',
      icon: WorkOffIcon,
      data: mappedLeaveTypes,
      subtitle: t('integrations.personio.leave types').toLowerCase()
    }
  ];

  return (
    <>
      {stepsData.map(step => (
        <Step
          title={`${t('integrations.step')} ${step.stepNumber}`}
          subtitle={`${t('integrations.personio.select the types you want to synchronize', { type: step.subtitle })}:`}
          Icon={step.icon}
          key={step.stepNumber}
        >
          <Grid2 xs={12}>
            <SelectCheckbox {...step} />
          </Grid2>
        </Step>
      ))}
    </>
  );
};
